import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Warm%20cozy%20anime%20illustration%20of%20a%20cheerful%20gyaru%20girl%20with%20tanned%20skin%20and%20light%20blonde%20hair%20and%20a%20shy%20teenage%20boy%20sitting%20together%20reading%20comic%20books%20on%20a%20sofa%20in%20a%20bright%20living%20room%20at%20sunset%2C%20soft%20golden%20light%2C%20romance%20comedy%20mood%2C%20pastel%20coral%20and%20peach%20color%20palette%2C%20clean%20vibrant%20anime%20art%2C%20high%20detail&width=1600&height=900&seq=hero-main&orientation=landscape')",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55" />

      <div className="relative z-10 flex w-full flex-col items-center px-4 pb-14 pt-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-book-open-line" />
          青春恋爱喜剧漫画
        </span>
        <h1 className="mt-5 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          泡在我家的辣妹
        </h1>
        <p className="mt-4 font-heading text-lg text-accent-200 md:text-xl">
          漫画剧情介绍 · 故事主线 · 核心设定 · 分集看点
        </p>
        <p className="mt-5 max-w-2xl text-sm leading-7 text-background-100/90 md:text-base md:leading-8">
          想知道这部漫画到底讲了什么？这里汇总《泡在我家的辣妹》的故事主线、漫画介绍与核心设定，
          帮你快速理清分集剧情走向——看漫画前先补课，追更不迷路。
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/plot"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            查看剧情介绍
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/characters"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 cursor-pointer"
          >
            认识主要角色
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-background-50/80 animate-bounce">
        <i className="ri-arrow-down-line text-xl" />
      </div>
    </section>
  );
}